module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('t-button', {
    attrs: {
      "size": "sm"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onPopperCancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeCancelText))]), _vm._v(" "), _c('t-button', {
    attrs: {
      "type": "primary",
      "size": "sm"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onPopperConfirm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeOkText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c58d13a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poptip/popper-button.vue
// module id = 396
// module chunks = 0